import React, { useState } from "react";
import "./FooterForm.css";

const FooterForm = () => {
    const [name , setName] = useState('');
    const [email , setEmail] = useState('');
    const [subject, setSubject] = useState("");
    const [textArea , setTextArea] = useState("");


    const handleSubmit = (e) =>{
          e.preventDefault()
            //   console.log(name)
            //   console.log(email)
            //   console.log(subject)
            //   console.log(textArea)
    } 
  return (
    <>
      <div className="footer-form">
        <div className="footer-form-box">
          <h2>LET'S GET IN TOUCH</h2>
          <form onSubmit={handleSubmit}>
          <div className="form-card">
            <input
              value={name}
              onChange={(e) =>setName(e.target.value)}
              type="text"
              name="name"
              id="name"
              placeholder="YOURNAME...*"
            />
            <input
              value={email}
              onChange={(e) =>setEmail(e.target.value)}
              type="email"
              name="email"
              id="email"
              placeholder="YOUR EMAIL..."
            />
            <input
              value={subject}
              onChange={(e) =>setSubject(e.target.value)}
              type="text"
              name="subject"
              id="subject"
              placeholder="SUBJECT...*"
            />
            </div>
            <textarea
              value={textArea}
              onChange={(e) =>setTextArea(e.target.value)}
              type="message"
              name="message"
              id="message"
              placeholder="YOUR MESSAGE..."
            ></textarea>
            <button type="submit">SEND MESSAGE NOW</button>
          </form>
        </div>
        <div className="footer-contact">
        <div className="footer-contact-box">
          <h6>
            Register Complaint 
            <span> 
              <a href="/"> Click Here</a>
            </span>
          </h6>
          </div>
          <div className="footer-contact-box">
          <h6>
            Email Address
            <span> Complaint@pmyp.gov.pk</span>
          </h6>
          </div>
          <div className="footer-contact-box">
          <h6>Website URL 
          <span>
              <a href="/"> https://pmyp.gov.pk/</a>
            </span></h6>
            </div>
        </div>
      </div>
    </>
  );
};

export default FooterForm;
